// extracted by mini-css-extract-plugin
export default {"presentationBlock":"Shop_presentationBlock__tb24F","title":"Shop_title__WL1QJ"};